import React from "react";

import "./ACIconGallery.less";

// @ts-ignore
const iconModules = import.meta.glob("../../ac-components/ac-icons/*.tsx", {
  eager: true,
});

const icons = Object.entries(iconModules).map(([path, module]) => {
  const name = path.split("/").pop()?.replace(".tsx", "") || "";
  // If your icon exports as default, otherwise adjust as needed
  const Component = (module as any).default;
  return { name, Component };
});

const ACIconGallery: React.FC = () => {
  return (
    <div className="icon-gallery-container">
      <h1 className="icon-gallery-title">ArmorCode AC Icon Gallery</h1>

      <div className="icon-grid">
        {icons
          .filter(({ name }: { name: string }) => !name.includes("/"))
          .map(
            ({
              name,
              Component,
            }: {
              name: string;
              Component: React.FC<any>;
            }) => (
              <div key={name} className="icon-item">
                <Component className="icon-svg" />
                <span className="icon-label">{name}</span>
              </div>
            ),
          )}
      </div>
    </div>
  );
};

export default ACIconGallery;
